import Select from "react-select";
import { useState } from "react";
import deleteIcon from "../../assets/icons/red-bin.svg";

const productObj = {
    id: "",
    product_id: "",
    name: "",
    description: "",
    photo_url: "",
    hsn_code: "",
    price: 0,
    billing_amount: 0,
    cash_amount: 0,
    quantity: 1,
    sgst_slab: 0,
    igst_slab: 0,
    cgst_slab: 0,
    sgst: 0,
    cgst: 0,
    igst: 0,
    total_before_tax: 0,
    total_after_tax: 0,
    total_cash_amount: 0,
};

const floatConverter = (value) => {
    var str = value.toFixed(2);

    var num = parseFloat(str);

    return num;
};

const OrderProductItem = ({
    products,
    productList,
    setOrderValues,
    setOrderProducts,
    delivery_state = "Karnataka",
    cartValues = [],
}) => {
    const [cart, setCart] = useState(cartValues);

    const [orderObj, setOrderObj] = useState({
        total_before_tax: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        total_after_tax: 0,
        total_cash_amount: 0,
        total_invoice_value: 0,
    });

    const updateOrderObjAndPrice = (cartItems) => {
        var orderObjNew = {
            total_before_tax: 0,
            cgst: 0,
            sgst: 0,
            igst: 0,
            total_after_tax: 0,
            total_cash_amount: 0,
            total_invoice_value: 0,
        };
        for (let index = 0; index < cartItems.length; index++) {
            const element = cartItems[index];
            var sgst = 0;
            var cgst = 0;
            var igst = 0;
            var total_before_tax = 0;
            var total_after_tax = 0;
            var total_cash_amount = 0;
            try {
                total_before_tax = element.billing_amount * element.quantity;
                total_before_tax = floatConverter(total_before_tax ?? 0);

                total_cash_amount = element.cash_amount * element.quantity;
                total_cash_amount = floatConverter(total_cash_amount ?? 0);

                if (delivery_state !== "Karnataka") {
                    //igst
                    igst = (total_before_tax / 100) * element.igst_slab;
                    igst = floatConverter(igst ?? 0);
                } else {
                    //cgst
                    sgst = (total_before_tax / 100) * element.sgst_slab;
                    sgst = floatConverter(sgst ?? 0);

                    cgst = (total_before_tax  * element.cgst_slab)/100;
                    cgst = floatConverter(cgst ?? 0);
                }

                total_after_tax = total_before_tax + igst + sgst + cgst;
                total_after_tax = floatConverter(total_after_tax ?? 0);

                cartItems[index].sgst = sgst;
                cartItems[index].cgst = cgst;
                cartItems[index].igst = igst;
                cartItems[index].total_before_tax = total_before_tax;
                cartItems[index].total_after_tax = total_after_tax;
                cartItems[index].total_cash_amount = total_cash_amount;

                orderObjNew.total_before_tax =
                    orderObjNew.total_before_tax + total_before_tax;
                orderObjNew.cgst = orderObjNew.cgst + cgst;
                orderObjNew.sgst = orderObjNew.sgst + sgst;
                orderObjNew.igst = orderObjNew.igst + igst;
                orderObjNew.total_after_tax =
                    orderObjNew.total_after_tax + total_after_tax;
                orderObjNew.total_cash_amount =
                    orderObjNew.total_cash_amount + total_cash_amount;
                orderObjNew.total_invoice_value =
                    orderObjNew.total_cash_amount +
                    orderObjNew.total_after_tax;

                orderObjNew.total_before_tax = floatConverter(
                    orderObjNew.total_before_tax ?? 0
                );
                orderObjNew.cgst = floatConverter(orderObjNew.cgst ?? 0);
                orderObjNew.sgst = floatConverter(orderObjNew.sgst ?? 0);
                orderObjNew.igst = floatConverter(orderObjNew.igst ?? 0);
                orderObjNew.total_after_tax = floatConverter(
                    orderObjNew.total_after_tax ?? 0
                );
                orderObjNew.total_cash_amount = floatConverter(
                    orderObjNew.total_cash_amount ?? 0
                );
                orderObjNew.total_invoice_value = floatConverter(
                    orderObjNew.total_invoice_value ?? 0
                );
            } catch (error) {
                console.log("error", error);
            }

            console.log("cartItems", cartItems,orderObjNew );
            
        }
        setCart([...cartItems]);
        setOrderObj({
            ...orderObjNew,
        });

        setOrderProducts([...cartItems]);
        setOrderValues({
            ...orderObjNew,
        });
    };

    const updateCartItem = (index, product) => {
        var cartArr = [...cart];
        var productObjNew = {
            ...cartArr[index],
        };

        productObjNew.product_id = product.id;
        productObjNew.name = product.name;
        productObjNew.description = product.description;
        productObjNew.photo_url = product.photo_url ?? "";
        productObjNew.hsn_code = product.hsn_code ?? "";
        productObjNew.price = product.price ?? 0;
        productObjNew.billing_amount = product.price ?? 0;
        productObjNew.cash_amount = 0;
        productObjNew.quantity = 1;
        productObjNew.sgst_slab = product.sgst ?? 0;
        productObjNew.igst_slab = product.igst ?? 0;
        productObjNew.cgst_slab = product.cgst ?? 0;
        productObjNew.sgst = 0;
        productObjNew.cgst = 0;
        productObjNew.igst = 0;
        productObjNew.total_before_tax = 0;
        productObjNew.total_after_tax = 0;
        productObjNew.total_cash_amount = 0;
        cartArr[index] = { ...productObjNew };

        updateOrderObjAndPrice([...cartArr]);
    };
    const updateValue = (index, key, value) => {
        var cartArr = [...cart];
        cartArr[index][key] = value;

        updateOrderObjAndPrice([...cartArr]);
    };

    return (
        <div>
            <h1 className="text-center text-fs_20 font-fw_500 mb-2">Items</h1>

            <div className="flex flex-col gap-1 border rounded pb-5 bg-[#F1F5F9] w-full overflow-x-auto">
                <div className="flex items-center gap-2 pt-2 px-4 text-fs_14 min-w-[1200px]">
                    <div className="me-2">ID</div>
                    <div className="w-[250px] min-w-[200px] max-w-[200px]">
                        Product
                    </div>
                    <div className="w-full min-w-[150px] max-w-[150px]">
                        Name
                    </div>
                    <div className=" w-full min-w-[150px] max-w-[150px]">
                        Description
                    </div>
                    <div className=" w-full min-w-[120px] max-w-[120px]">
                        Qty
                    </div>
                    <div className=" w-full min-w-[120px] max-w-[120px]">
                        Price
                    </div>
                    <div className=" w-full min-w-[120px] max-w-[120px]">
                        Billing Amount
                    </div>
                    <div className=" w-full min-w-[120px] max-w-[120px]">
                        Cash Amount
                    </div>
                    <div className=" w-full min-w-[120px] max-w-[100px]">
                        S-GST
                    </div>
                    <div className=" w-full min-w-[120px] max-w-[100px]">
                        C-GST
                    </div>
                    <div className=" w-full min-w-[120px] max-w-[100px]">
                        I-GST
                    </div>
                    <div className=" w-full min-w-[120px] max-w-[100px]">
                        HSN Code
                    </div>
                    <div className=" w-full min-w-[120px] max-w-[100px]">
                        GST Total
                    </div>
                    <div className=" w-full min-w-[120px] max-w-[100px]">
                        Cash Total
                    </div>
                </div>
                {cart.map((item, index) => {
                    return (
                        <div
                            key={index}
                            className="flex items-center gap-2 pb-2 px-4 min-w-[1200px]"
                        >
                            <div className="me-2">
                                <div className="">{index + 1}</div>
                            </div>
                            <div className="w-[250px] min-w-[200px]  max-w-[200px]">
                                <div
                                    className={`border-[1px] rounded-lg px-[0.2rem] py-[0.1rem] pb-[0.4rem] mt-1 w-full border-greyText`}
                                >
                                    <Select
                                        options={productList}
                                        placeholder={"select product"}
                                        onChange={(selectedItem) => {
                                            var foundProduct = products.find(
                                                (i) =>
                                                    i.id == selectedItem.value
                                            );
                                            console.log(
                                                "selectedItem",
                                                selectedItem,
                                                foundProduct,
                                                products
                                            );
                                            updateCartItem(index, foundProduct);
                                        }}
                                        styles={customStyles}
                                        // required={true}
                                    />
                                </div>
                            </div>
                            <div className=" w-full min-w-[150px] max-w-[150px]">
                                <input
                                    name={`name`}
                                    label={"name"}
                                    placeholder={`Name`}
                                    value={`${cart[index].name}`}
                                    onChange={(e) => {
                                        updateValue(
                                            index,
                                            "name",
                                            e.target.value
                                        );
                                    }}
                                    className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px] disabled:opacity-45
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                                />
                            </div>
                            <div className=" w-full min-w-[150px] max-w-[150px]">
                                <input
                                    name={`description`}
                                    label={"description"}
                                    value={`${cart[index].description}`}
                                    placeholder={`Description`}
                                    onChange={(e) => {
                                        updateValue(
                                            index,
                                            "description",
                                            e.target.value
                                        );
                                    }}
                                    className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px] disabled:opacity-45
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                                />
                            </div>

                            <div className=" w-full min-w-[120px] max-w-[120px]">
                                <input
                                    name={`qty`}
                                    label={"Qty"}
                                    placeholder={`Enter Qty`}
                                    value={`${cart[index].quantity}`}
                                    onChange={(e) => {
                                        updateValue(
                                            index,
                                            "quantity",
                                            e.target.value
                                        );
                                    }}
                                    className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px] disabled:opacity-45
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                                />
                            </div>
                            <div className=" w-full min-w-[120px] max-w-[120px]">
                                <input
                                    name={`price`}
                                    label={"Price"}
                                    placeholder={`Enter price`}
                                    value={`${cart[index].price}`}
                                    onChange={(e) => {
                                        updateValue(
                                            index,
                                            "price",
                                            e.target.value
                                        );
                                    }}
                                    className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px] disabled:opacity-45
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                                />
                            </div>
                            <div className=" w-full min-w-[120px] max-w-[100px]">
                                <input
                                    name={`customer_obj.${index}.billingAmount`}
                                    label={"Billing Amount"}
                                    placeholder={`Enter billing amount`}
                                    onChange={(e) => {
                                        updateValue(
                                            index,
                                            "billing_amount",
                                            e.target.value
                                        );
                                    }}
                                    value={cart[index].billing_amount}
                                    className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px] disabled:opacity-45
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                                />
                            </div>
                            <div className=" w-full min-w-[120px] max-w-[100px]">
                                <input
                                    name={`customer_obj.${index}.cashAmount`}
                                    label={"Cash Amount"}
                                    placeholder={`Enter cash amount`}
                                    onChange={(e) => {
                                        updateValue(
                                            index,
                                            "cash_amount",
                                            e.target.value
                                        );
                                    }}
                                    value={cart[index].cash_amount}
                                    className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px] disabled:opacity-45
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                                />
                            </div>
                            <div className=" w-full min-w-[120px] max-w-[100px]">
                                <input
                                    name={`sgst`}
                                    label={"SGST"}
                                    placeholder={`sgst`}
                                    value={` ${cart[index].sgst_slab}% | ${cart[index].sgst}`}
                                    disabled={true}
                                    className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px] disabled:opacity-45
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                                />
                            </div>
                            <div className=" w-full min-w-[120px] max-w-[100px]">
                                <input
                                    name={`cgst`}
                                    label={"CGST"}
                                    placeholder={`cgst`}
                                    disabled={true}
                                    value={` ${cart[index].cgst_slab}% | ${cart[index].cgst}`}
                                    className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px] disabled:opacity-45
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                                />
                            </div>
                            <div className=" w-full min-w-[120px] max-w-[100px]">
                                <input
                                    name={`igst`}
                                    label={"IGST"}
                                    placeholder={`igst`}
                                    disabled={true}
                                    value={` ${cart[index].igst_slab}% | ${cart[index].igst}`}
                                    className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px] disabled:opacity-45
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                                />
                            </div>
                            <div className=" w-full min-w-[120px] max-w-[80px]">
                                <input
                                    name={`HSN Code`}
                                    label={"HSN"}
                                    placeholder={`HSN Code`}
                                    value={`${cart[index].hsn_code}`}
                                    disabled={true}
                                    className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px] disabled:opacity-45
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                                />
                            </div>
                            <div className=" w-full min-w-[120px] max-w-[80px]">
                                <input
                                    name={`.gstTotal`}
                                    label={"Tax Total"}
                                    placeholder={`gst Total`}
                                    value={`${cart[index].total_after_tax}`}
                                    disabled={true}
                                    className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px] disabled:opacity-45
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                                />
                            </div>
                            <div className=" w-full min-w-[120px] max-w-[80px]">
                                <input
                                    type="number"
                                    name={`cashTotal`}
                                    label={"Cash Total"}
                                    placeholder={`cash Total`}
                                    value={`${cart[index].total_cash_amount}`}
                                    disabled={true}
                                    className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px] disabled:opacity-45
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                                />
                            </div>

                            {/* Delete Button */}
                            <div className="flex items-center">
                                <button
                                    type="button"
                                    className="text-red-500 w-[24px]"
                                    onClick={() => {
                                        var cartArr = [...cart];

                                        const removedElements = cartArr.splice(
                                            index,
                                            1
                                        );
                                        setCart([...cartArr]);
                                    }}
                                >
                                    <img
                                        src={deleteIcon}
                                        alt="U"
                                        width={18}
                                        height={18}
                                    />
                                </button>
                            </div>
                        </div>
                    );
                })}

                <div className="flex justify-center">
                    <button
                        type="button"
                        onClick={() => {
                            setCart([...cart, { ...productObj }]);
                        }}
                        className="bg-blue-500 text-white px-4 py-2 rounded w-fit"
                    >
                        Add Item
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OrderProductItem;

const customStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 }) ,
    indicatorSeparator: () => ({ display: "none" }),
    control: (base, state) => ({
        ...base,
        color: "#0000",
        width: "100%",
        border: "none",
        boxShadow: state.isFocused ? null : null,
    }),
    placeholder: (defaultStyles) => ({
        ...defaultStyles,
        color: "#B0B3C7",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    }),
    multiValueRemove: (styles) => ({
        ...styles,
        color: "#50BF97",
        ":hover": {
            backgroundColor: "#50BF97",
            color: "white",
        },
    }),
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? "white" : "black",
        backgroundColor: state.isSelected ? "#50BF97" : "white",
        ":hover": {
            backgroundColor: "#50BF97",
            color: "white",
        },
    }),
};
